import "./index.scss";
import { NavLink } from "hooks/useCustomNavigation";
import { INTERNAL_PATHS } from "routes/paths";

export const CartShipping = () => {
  const { SHIPPING_POLICY, GUARANTEE, RAISE_CASH_TERMS } = INTERNAL_PATHS;

  return (
    <div className="cart-shipping">
      <div>
        <NavLink to={SHIPPING_POLICY}>Shipping &amp; Delivery</NavLink>
        <span className="divider">|</span>
        <NavLink to={GUARANTEE}>90 Day Money-Back Guarantee</NavLink>
        <span className="divider">|</span>
        <NavLink to={RAISE_CASH_TERMS}>GCX Cash Terms</NavLink>
      </div>
      <p>
        Most orders are processed immediately, but please allow up to 24 hours.
        Delivery times may vary for each gift card in a single order. The price
        and availability of gift cards on GCX are subject to change. The cart is
        a place to store your gift cards and reflects each item's most recent
        price.
      </p>
    </div>
  );
};
